/* eslint-disable max-len */
import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

const useStyle = makeStyles(() => {
    return {
        root: {
            fill: 'currentColor',
        },
    };
});


interface RitzLogoProps {
    readonly className?: string;
}

export const RitzLogo: React.FC<RitzLogoProps> = (props: RitzLogoProps) => {
    const classes = useStyle();
    return (
        <svg className={clsx(props.className, classes.root)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
            <defs />
            <path d="M136.18 58.44c-13.02 3.83-22.02 9-45.75 26.8-32.74 24.7-60.69 55.13-71.98 78.3-16.27 33.5-8.23 144.15 17.23 236.62 22.97 83.65 62.6 168.27 111.22 237.38 93.62 133.43 221.5 230.11 367.57 277.59 58.2 18.95 129.41 30.82 169.8 28.14 14.93-.96 18.95-2.11 34.46-9.76 22.4-10.72 45.18-27.76 68.54-50.92 39.25-39.05 47.48-59.16 39.05-95.34-4.79-19.91-19.33-50.16-28.14-58.39-16.08-14.74-59.54-34.46-121.95-54.76-51.69-17.04-66.05-20.29-79.06-17.61-17.61 3.64-35.99 16.27-80.79 55.52l-20.87 18.19-11.68-6.32c-43.45-23.74-108.92-76.38-155.64-125.01-43.84-45.95-94.37-121.37-116.2-173.83-4.59-11.1-9-21.82-9.57-24.12-.96-3.06 2.49-7.08 18.76-21.44 43.65-38.86 64.71-64.32 67.39-81.94 1.34-8.81-5.74-53.41-14.74-94.57-14.74-66.62-29.1-103.95-44.41-115.06-35.81-26.03-68.35-36.37-93.24-29.47z" />
            <path d="M484.03 89.26c-35.42 6.32-69.3 23.55-98.4 49.97l-8.23 7.27 24.12 28.33 24.12 28.33 8.8-7.47c15.89-13.4 38.86-26.99 51.5-31.01 29.1-9 56.48-2.87 67.77 14.74 12.44 19.91 7.66 55.33-11.87 87.87-10.34 17.04-31.01 40.97-98.97 114.1l-63.56 68.34v63.37h281.42v-74.66h-85c-58.2 0-85.57-.57-86.34-2.11-.77-1.15 21.63-25.27 50.16-53.99 57.05-57.62 77.15-82.51 92.46-113.33 12.44-25.27 15.89-39.24 16.08-64.13 0-23.55-2.49-35.99-11.87-55.52-7.66-16.46-26.04-36.18-41.35-44.6-30.44-16.84-71.6-22.59-110.84-15.5zM769.46 228.24l-89.59 136.11v60.69h174.2v88.06h86.14v-88.06H990v-68.92h-49.78V91.94h-81.36l-89.4 136.3zm87.68-23.93c-.57 4.02-1.53 39.82-2.3 79.45l-1.34 72.36h-94.96l36.37-55.13c22.97-34.65 40.78-63.94 48.24-79.26 6.51-13.4 12.64-24.31 13.59-24.5.78 0 1.17 3.25.4 7.08z" />
        </svg>
    );
};
